import register from '@kpsys/angularjs-register';
import valueEditorsBaseModule from './value-editors.base.module';
import {valueEditorsOptionsConfig} from './value-editors-options.config';
import {valueEditorsLocalizationsConfig} from './value-editors-localization.config';
import SearchableValueEditorService from './custom-editors-services/searchable-value-editor.service';
import {Field7ValueEditorService} from './custom-editors-services/field7-value-editor.service';
import {Field8ValueEditorService} from './custom-editors-services/field8-value-editor.service';
import {AuthorityField8ValueEditorService} from './custom-editors-services/authority-field8-value-editor.service';

export default register('portaro.shared.value-editors.portaro-editors', [valueEditorsBaseModule])
    .run(valueEditorsOptionsConfig)
    .run(valueEditorsLocalizationsConfig)
    .service(SearchableValueEditorService.serviceName, SearchableValueEditorService)
    .service(Field7ValueEditorService.serviceName, Field7ValueEditorService)
    .service(Field8ValueEditorService.serviceName, Field8ValueEditorService)
    .service(AuthorityField8ValueEditorService.serviceName, AuthorityField8ValueEditorService)
    .name();